import PostRequest from "csi/comm/PostRequest";
import config from "csi/config";
import locale from "csi/locale";
import Controller from "csi/table/Delete";
import MessageDialog from "csi/widget/MessageDialog";
import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";

const LOCK_SHAPE_DIMENSION_LIST = "LockShapeDimensionList";

const ShapeSCDSLineDeleteController = declare(Controller, {
	/**
     * @override
     */
	confirmAction(params: any) {
		const sizeChart = this.getCache().getPathNode(this.m_urlParent, "Child:__Parent__");
		const lockShapeDimensionList = config.getSubtypeSetting(sizeChart?.Subtype, LOCK_SHAPE_DIMENSION_LIST);
		const dimName = locale.getNodeName(this.getNode());

		if (!lockShapeDimensionList && sizeChart.StyleSizeCharts.length > 0) {
			params.message = locale.typeAction("SizeChartDimension", "ShapeSizeChartDimensionDeleteAndUnlink_Confirm", [dimName]);
			this.m_action.confirmAction = MessageDialog.BUTTON_UNLINK_AND_DELETE;
		} else {
			params.message = locale.typeAction("SizeChartDimension", "ShapeSizeChartDimensionDelete_Confirm", [dimName]);
			this.m_action.confirmAction = MessageDialog.BUTTON_DELETE;
		}
		this.inherited(arguments);
	},

	/**
     * @override
     * issue request so as to be able to receive return value
     */
	process() {
		const req = this.m_action.m_request;
		this.setProgress();
		new PostRequest(req.m_module, req.m_operation)
			.addParameter("ParentURL", this.m_urlParent)
			.addParameter("URLs", [this.m_urlNode])
			.post({})
			.then(lang.hitch(this, this._onPublishResponse));
	},
});

export = ShapeSCDSLineDeleteController;
